import { LimitBlock } from './LimitBlock'

export function TopExtendMiddle() {
  return (
    <div className='w-full bg-primary-600 flex flex-col items-center d-py-[80px]'>
      <h2 className='font-semibold d-text-[34px] d-leading-[48px] d-tracking-[1.7px]'>
        アプリを早速使ってみよう
      </h2>
      <p className='d-mt-[10px] d-text-[18px] d-leading-[38px] d-tracking-[1.8px]'>
        スマホのカメラを起動して下のコードを読み取ってください。
      </p>

      <div className='relative flex justify-center mb-[61px]'>
        <img
          src='/images/assets/get_start_qr/bg@pc.webp'
          alt='アプリを早速使ってみよう'
          className='object-contain d-w-[1000px] d-h-[436px] d-mt-[24px]'
        />
        <img
          src='/images/assets/get_start_qr/qr_top.webp'
          alt='アプリを早速使ってみようQR'
          className='object-contain d-w-[170px] d-h-[170px] absolute z-10 d-bottom-[85px]'
        />
      </div>

      <LimitBlock />
    </div>
  )
}
